const enums = {
  LINKS: [
    { title: 'Tasks', link: '/tasks' },
    { title: 'Catalog', link: '/catalog' },
    { title: 'Print Setup', link: '/print' },
    { title: 'Promo Setup', link: '/promo' },
    {
      title: 'Content',
      allowContentAdmin: true,
      link: '/content'
    },
    { title: 'Users', link: '/users' },
    {
      title: 'Marketing',
      children: [
        // "Overview", not "Dashboard" — the sidebar already has a top-level Dashboard.
        { title: 'Overview', link: '/marketing' },
        { title: 'Campaigns', link: '/marketing/campaigns' },
        { title: 'Audiences', link: '/marketing/audiences' },
        // "Subject lines", not "Email performance": it reports on the subject line specifically, and the
        // per-campaign Results card already owns how one email did.
        { title: 'Subject lines', link: '/marketing/subjects' },
        // Named "Retargeting" rather than "Ad Audiences": "Audiences" above already means
        // Industry/Topic content planning, and two meanings of the word in one menu is a trap.
        { title: 'Retargeting', link: '/marketing/retargeting' },
        // Every email we send: receipts, account emails and automations (templates on Resend).
        { title: 'Emails', link: '/marketing/emails' }
      ]
    },
    {
      title: 'Orders',
      children: [
        { title: 'Queue', link: '/orders/queue' },
        { title: 'Completed', link: '/orders/completed' }
      ]
    },
    {
      title: 'Reports',
      children: [
        { title: 'Ad Campaigns', link: '/reports/campaigns' },
        { title: 'Ads', link: '/reports/ads' }
      ]
    },
    {
      title: 'Settings',
      children: [
        { title: 'Reviews', link: '/reviews' },
        { title: 'Promo Codes', link: '/promocodes' },
        { title: 'Guides', link: '/guides' },
        { title: 'Outputs', link: '/outputs' }
      ]
    }
  ],
  DESIGN_PROJECT_STATUS: {
    PENDING: 1,
    OPEN: 2,
    ASSIGNED: 3,
    UNDER_REVIEW: 4,
    COMPLETE: 5
  },
  EVENT_BUS_EVENTS: {
    SEARCH_USERS: 'searchUsers',
    CATALOG_ADD_SHOW: 'catalog_add_show',
    CATALOG_ADD_HIDE: 'catalog_add_hide',
    ADD_TRACKING_SHOW: 'add_tracking_show',
    JOB_VALIDATE_SHOW: 'job_validate_show',
    SET_NAV_VISIBILITY: 'set_nav_visibility',
    SET_PRINT_JOB_DRAWER_VISIBILITY: 'set_print_job_visibility',
    ADD_CORE_PRODUCT_SHOW: 'add_core_product_show',
    EDIT_GUIDE_SHOW: 'edit_guide_show',
    EDIT_OUTPUT_SHOW: 'edit_output_show',
    EDIT_TEMPLATE_SHOW: 'edit_template_show',
    EDIT_CATALOG_PAGE_SHOW: 'edit_catalog_page_show',
    FILTER_4OVER_SHOW: 'filter_4over_show',
    FILTER_CATALOG_PAGE_SHOW: 'filter_catalog_page_show',
    EDIT_BLOG_POST_SHOW: 'edit_blog_post_show',
    FILTER_BLOG_POST_SHOW: 'filter_blog_post_show',
    EDIT_SNIPPET_SHOW: 'edit_snippet_show',
    EDIT_CATALOG_PAGE_QUESTION_SHOW: 'edit_catalog_page_question_show',
    EDIT_BLOG_POST_BODY_SHOW: 'edit_blog_post_body_show',
    DESIGN_GROUP_CATEGORY_SHOW: 'design_group_category_show',
    DESIGN_GROUP_CATEGORY_LIST_SHOW: 'design_group_category_list_show',
    EDIT_BLOG_POST_IMAGE_SHOW: 'edit_blog_post_image_show',
    INSPIRATIONAL_IMAGES_ADD_MORE_SHOW: 'inspirational_images_add_more_show',
    COPY_TEMPLATE_SHOW: 'copy_template_show',
    PAY_DRAWER_SHOW: 'pay_drawer_show',
    REVIEW_EDIT_SHOW: 'review_edit_show',
    PROMO_CODE_EDIT_SHOW: 'promo_code_edit_show',
    ADD_PRINT_PRODUCT_SHOW: 'add_print_product_show',
    EDIT_PRINT_QUANTITY_SHOW: 'edit_print_quantity_show',
    ADD_PRINT_OPTION_IMAGE_SHOW: 'add_print_option_image_show',
    ADD_4OVER_PRODUCTS_SHOW: 'add_4over_products_show',
    CACHE_SYNC_SHOW: 'cache_sync_show',
    PAGE_ADD_SHOW: 'page_add_show',
    PAGE_ADD_SAVED: 'page_add_saved'
  },
  DRAWER: { EDIT_PRODUCT: 'edit_product' },
  UNITS: {
    INCHES: 1,
    MILLIMETERS: 2
  },
  CATALOG_TABS: [
    {
      id: 'categories',
      name: 'Category',
      add: 'Create Category',
      store: 'categories'
    },
    {
      id: 'products',
      name: 'Core Products'
    },
    {
      id: 'industries',
      name: 'Industry',
      add: 'Create Industry',
      store: 'industries'
    },
    { id: 'topics', name: 'Topic', add: 'Create Topic', store: 'topics' },
    {
      id: 'designgroups',
      name: 'Design Group',
      add: 'Create Design Group',
      store: 'designgroups'
    },
    {
      id: 'templates',
      name: 'Templates',
      add: 'Create Template',
      store: 'templates'
    },
    {
      id: 'projects',
      name: 'Projects'
    },
    {
      id: 'missing-templates',
      name: 'Missing Templates'
    },
    {
      id: 'copy-templates',
      name: 'Copy Templates',
      store: 'templates',
      loadAction: 'loadCopy'
    },
    {
      id: 'replace-templates',
      name: 'Replace Templates',
      store: 'templates',
      loadAction: 'loadReplace'
    }
  ],
  CONTENT_TABS: [
    { id: 'pages', name: 'Pages' },
    { id: 'questions', name: 'Mailing Questions' },
    { id: 'catalog', name: 'Catalog' },
    { id: 'authors', name: 'Authors' },
    { id: 'images', name: 'Images' }
  ],
  TASK_TABS: [{ id: 'list', name: 'Tasks' }],
  PRINT_TABS: [
    { id: 'products', name: 'Products' },
    { id: 'stocks', name: 'Stocks' },
    { id: 'finishes', name: 'Finishes' },
    { id: 'materials', name: 'Materials' },
    { id: 'categorymaterials', name: 'Category Materials' },
    { id: 'options', name: 'Options' },
    { id: 'optiongroups', name: 'Option Groups' },
    { id: 'turnaroundtypes', name: 'Turnaround Types' },
    { id: '4over', name: '4Over Products' }
  ],
  PROMO_TABS: [{ id: 'products', name: 'Products' }],
  NOTE_TYPE: [
    {
      id: 'categories',
      name: 'Category',
      legendWidth: 100,
      store: 'categories'
    },
    {
      id: 'industries',
      name: 'Industry',
      legendWidth: 90,
      store: 'industries'
    },
    { id: 'topics', name: 'Topic', legendWidth: 80, store: 'topics' },
    {
      id: 'designgroups',
      name: 'Design Group',
      legendWidth: 125,
      store: 'designgroups'
    },
    {
      id: 'designgroupcategory',
      name: 'Design Group/Category',
      legendWidth: 187,
      link: '/designgroups/{id}'
    }
  ],
  PROVIDER: { FOUROVER: 1 },
  DRAWERS: {
    PRINT_JOB_DETAIL: 'printJobDetail',
    PRINT_JOB_EDIT_ADDRESS: 'printJobEditAddress',
    PRINT_JOB_ADD_TRACKING: 'prinJobAddTracking',
    PRINT_JOB_ADD_EXTERNAL_JOB: 'printJobAddExternalJob',
    PRINT_JOB_SYNC: 'printJobSync',
    PRINT_JOB_VALIDATE_COSTS: 'printJobValidateCosts',
    PROMO_JOB_DETAIL: 'promoJobDetail'
  },
  ROLES: { ADMIN: 'Admin', CONTENT_ADMIN: 'Content_Admin' },
  EMOJI: { THOUGHT: '💭' },
  BLOG_POST_TYPE: {
    ARTICLE: 1,
    FAQ: 2
  },
  REVIEW_STATUS: { PENDING: 1 },
  INDUSTRY_TYPE: {
    BUSINESS: 1,
    PURPOSE: 2
  },
  FOLD_TYPE: { NONE: 3 },
  SNAILBLAST: {
    CAMPAIGN_TYPE: {
      EDDM: 1,
      DIRECT: 2,
      LIST_PURCHASE: 3
    }
  },
  MFG_TYPE: {
    VERTICAL_V1: 5,
    VERTICAL_V2: 6
  },
  MARKETING: {
    CAMPAIGN_STATUS: {
      1: { label: 'Draft', color: 'grey' },
      2: { label: 'Scheduled', color: 'info' },
      3: { label: 'Sending', color: 'warning' },
      4: { label: 'Sent', color: 'success' },
      5: { label: 'Failed', color: 'error' }
    },
    CAMPAIGN_STATUS_IDS: { DRAFT: 1, SCHEDULED: 2, SENDING: 3, SENT: 4, FAILED: 5 },
    ITEM_STATUS: {
      1: { label: 'Draft', color: 'grey' },
      2: { label: 'Approved', color: 'primary' },
      3: { label: 'Sent', color: 'success' },
      4: { label: 'Failed', color: 'error' }
    },
    ITEM_STATUS_IDS: { DRAFT: 1, APPROVED: 2, SENT: 3, FAILED: 4 },
    // Ads campaigns are deliberately absent from the campaigns list and calendar — they have no send date and
    // live on the Retargeting screen. See CampaignType.Ads in CampaignEnums.cs.
    CAMPAIGN_TYPE: { EMAIL: 1, SOCIAL: 2, ADS: 3 },
    CHANNEL: { EMAIL: 1, SOCIAL: 2, ADS: 3 },
    PLATFORM: {
      1: 'Pinterest',
      2: 'Facebook',
      3: 'Instagram',
      4: 'X',
      5: 'LinkedIn',
      6: 'Google Display'
    },
    PLATFORM_IDS: { PINTEREST: 1, FACEBOOK: 2, INSTAGRAM: 3, X: 4, LINKEDIN: 5, GOOGLE_DISPLAY: 6 },
    OBJECTIVE: {
      1: 'Awareness',
      2: 'Traffic',
      3: 'Promotion',
      4: 'Seasonal',
      5: 'ProductLaunch',
      6: 'Engagement'
    },
    // One line per objective explaining what it does to the generated email. Keep in sync with OBJECTIVE above and
    // with the conversion set in CampaignService.DefaultTargetUrl (Traffic/Promotion/Seasonal/ProductLaunch), which
    // is what decides whether links go to the "start designing" page or the informational one.
    OBJECTIVE_HINT: {
      1: 'Awareness — introduces who we are and what we make. Softer copy, no hard ask; links go to the ' +
        'informational landing page.',
      2: 'Traffic — written to get the click. Punchier subject and a clear call to action; links go straight to ' +
        'the "start designing" page.',
      3: 'Promotion — leads with the offer or discount. Urgency in the copy; links go straight to the ' +
        '"start designing" page.',
      4: 'Seasonal — hangs the message on the holiday or time of year. Timely copy; links go straight to the ' +
        '"start designing" page.',
      5: 'Product Launch — announces something new. Copy centers on what changed and why it matters; links go ' +
        'straight to the "start designing" page.',
      6: 'Engagement — asks for a reply, a read, or a share rather than a purchase. Conversational copy; links ' +
        'go to the informational landing page.'
    },
    TARGET_TYPE: {
      1: 'Category',
      2: 'Industry',
      3: 'Topic',
      4: 'ContentPage',
      // A design group narrows a campaign to one collection of designs. It is NOT an audience of its own — the
      // server resolves it to the topic/industry it hangs off for everything audience-shaped (see AUDIENCE.TYPE).
      5: 'DesignGroup'
    },
    // What a regenerate pass replaces. Mirrors CampaignRegenerateScope in CampaignEnums.cs.
    REGENERATE_SCOPE: { ALL: 0, COPY_ONLY: 1, IMAGE_ONLY: 2 }
  },
  // Mirrors MyCreativeShop.Models\Marketing\Audience\AudienceEnums.cs — keep the two in sync.
  AUDIENCE: {
    GAP_SEVERITY: {
      1: { label: 'Info', color: 'grey' },
      2: { label: 'Minor', color: 'warning' },
      3: { label: 'Major', color: 'error' }
    },
    // An audience is a campaign target of type Industry or Topic — the same ids as MARKETING.TARGET_TYPE.
    TYPE: { INDUSTRY: 2, TOPIC: 3 },
    PLAN_STATUS: {
      1: { label: 'Draft', color: 'grey' },
      2: { label: 'Active', color: 'success' },
      3: { label: 'Archived', color: 'grey darken-2' }
    },
    // How much runway the plan has left, derived server-side in AudiencePlanRunway from the sends its
    // campaigns hold. Shown in the status chip's place when it has something to say: nothing ever moves the
    // stored status off Active, so a plan that has run out reads exactly like a healthy one otherwise.
    // 1 (Booked) has no chip of its own — that IS the plan working, and "Active" already says it.
    PLAN_HEALTH: {
      2: { label: 'Needs next round', color: 'warning' },
      3: { label: 'Gone dark', color: 'error' }
    },
    PLAN_HEALTH_IDS: { NONE: 0, BOOKED: 1, NEEDS_NEXT_ROUND: 2, DARK: 3 },
    SECTION: { EXISTING: 1, NEW: 2, GAP: 3 },
    ITEM_TYPE: {
      1: { label: 'Email', icon: 'mdi-email-outline' },
      2: { label: 'Social post', icon: 'mdi-share-variant-outline' },
      3: { label: 'Page', icon: 'mdi-file-document-outline' },
      4: { label: 'Blog post', icon: 'mdi-post-outline' },
      5: { label: 'Templates', icon: 'mdi-palette-outline' },
      6: { label: 'Pinterest board', icon: 'mdi-pinterest' },
      7: { label: 'Other', icon: 'mdi-dots-horizontal' }
    },
    ITEM_STATUS: {
      1: { label: 'Suggested', color: 'grey' },
      2: { label: 'Approved', color: 'primary' },
      3: { label: 'Dismissed', color: 'error' },
      4: { label: 'Done', color: 'success' }
    },
    ITEM_STATUS_IDS: { SUGGESTED: 1, APPROVED: 2, DISMISSED: 3, DONE: 4 },
    GENERATION_STATUS: { IDLE: 1, QUEUED: 2, RUNNING: 3, FAILED: 4 },
    // How far along the designs an item asked for are. Derived server-side from the batches' jobs.
    TEMPLATE_STATUS: {
      1: { label: 'Suggested', color: '' },
      2: { label: 'Generating', color: 'success' },
      3: { label: 'Under Review', color: 'warning' },
      4: { label: 'Done', color: 'success' },
      5: { label: 'Dismissed', color: 'error' }
    },
    TEMPLATE_STATUS_IDS: { SUGGESTED: 1, GENERATING: 2, UNDER_REVIEW: 3, DONE: 4, DISMISSED: 5 }
  }
};

export default enums;
